import React from 'react';
import { useSelector } from 'react-redux';
import StatisticsProvider from '../../StatisticsProvider';
import LineChartGrid from '../../../../components/stats/LineChartGrid';

export default function Overview({ dateRangeFilter }) {
  const { company } = useSelector((state) => state.currentCompany);
  const { franchise } = company;

  return (
    <StatisticsProvider
      mainMetrics={[
        'sales',
        'average_order_value',
        'savings',
        'sales_from_email',
        'sales_from_google_seo',
        'sales_from_flyers',
        'tips',
        'new_customers',
        'returning_customers',
      ]}
      storefrontMetrics={franchise?.has_storefront ? ['website_visits', 'website_visitors'] : []}
      reservationMetrics={['total_reservations']}
      displayOrder={[
        'sales',
        'average_order_value',
        'savings',
        'tips',
        'total_reservations',
        'website_visits',
        'website_visitors',
        'new_customers',
        'returning_customers',
        'sales_from_email',
        'sales_from_google_seo',
        'sales_from_flyers',
      ]}
      withInterval
      dateRangeFilter={dateRangeFilter}
    >
      <LineChartGrid />
    </StatisticsProvider>
  );
}
